import { DescriptionFieldProps, FormContextType, RJSFSchema, StrictRJSFSchema } from '@snups/rjsf-utils';
import { RichDescription } from '@snups/rjsf-core';

/** The `DescriptionField` is the template to use to render the description of a field
 *
 * @param props - The `DescriptionFieldProps` for this component
 */
export default function DescriptionField<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>(props: DescriptionFieldProps<T, S, F>) {
  const { id, description, registry, uiSchema } = props;
  if (!description) {
    return null;
  }
  return (
    <span id={id}>
      <RichDescription description={description} registry={registry} uiSchema={uiSchema} />
    </span>
  );
}
